<template>
  <div class="wrap" style="overflow: hidden">
    <div class="content">
      <!-- 登录表单 -->
      <yd-cell-group v-if="!registerVisible">
        <h2 class="nav-title">用户登录</h2>
        <yd-cell-item>
          <span slot="left">手机号：</span>
          <yd-input
            slot="right"
            v-model="username"
            type="text"
            placeholder="请输注册后的手机号"
          />
        </yd-cell-item>
        <yd-cell-item>
          <span slot="left">密&nbsp;&nbsp;&nbsp;&nbsp;码：</span>
          <yd-input
            slot="right"
            v-model="password"
            type="password"
            placeholder="请输入密码"
          />
        </yd-cell-item>
        <yd-cell-item>
          <span slot="left">
            <yd-checkbox v-model="rememberPsw" color="#2f6fff"
              >记住密码</yd-checkbox
            ></span>
          <span slot="right">
            <router-link to="/forgotPassword" slot="left">
              <span style="color: #2f6fff;">忘记密码？</span>
            </router-link>
          </span>
        </yd-cell-item>
        <div style="margin-top: 180px">
          <yd-button
            type="primary"
            size="large"
            shape="circle"
            bgcolor="#2f6fff"
            color="#fff"
            @click.native="login"
            >登录</yd-button
          >
          <yd-button
            type="hollow"
            size="large"
            shape="circle"
            style="border: #2f6fff 1px solid"
            @click.native="
              () => {
                registerVisible = true;
              }
            "
            >注册</yd-button
          >
        </div>
        <div style="padding:20px;text-align: center;font-size: 16px;">
          首次使用系统请先注册账号
        </div>
		<div style="position: fixed;bottom: 10px;width: 100%; text-align: center;font-size: 14px;">
		  ©陕ICP备<a href="https://beian.miit.gov.cn/#/" style="color: #2f6fff;">2021000159号-2</a>
		</div>
      </yd-cell-group>
      <!-- 注册表单 -->
      <div
        style="
          padding: 15px;
          background: #ffffff;
          margin: 5px 10px;
          border-radius: 10px;
        "
        v-if="registerVisible"
      >
        <h2 class="nav-title">供应商注册</h2>
        <el-form
          ref="register"
          :rules="validRules"
          :model="register"
          label-width="120px"
          size="mini"
          label-position="left"
          inline-message="true"
        >
          <el-form-item label="供应商编码" prop="supplierNo">
            <!-- <span slot="label">
              <span> 供应商编码 </span><br />
              <span class="form-label-slot">(能源1号网编码)</span>
            </span> -->
            <el-input
              v-model="register.supplierNo"
              maxlength="50"
              placeholder="请输入十位能源1号网MDM编码"
              @blur="getSupplierName($event)"
            ></el-input>
          </el-form-item>
          <el-form-item label="供应商名称" prop="supplierName">
            <el-input
              v-model="register.supplierName"
              maxlength="100"
              placeholder="请输入供应商名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号码" prop="userPhone">
            <el-input
              v-model="register.userPhone"
              maxlength="20"
              placeholder="请输入手机号码"
            ></el-input>
          </el-form-item>
<!--          <el-form-item label="登录名" prop="userCode">-->
<!--            <el-input-->
<!--              v-model="register.userCode"-->
<!--              maxlength="20"-->
<!--              placeholder="请输入登录名"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
          <el-form-item label="姓名" prop="userName">
            <el-input
              v-model="register.userName"
              maxlength="10"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input
              v-model="register.password"
              show-password
              minlength="6"
              maxlength="15"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="passwordEnter">
            <el-input
              v-model="register.passwordEnter"
              show-password
              minlength="6"
              maxlength="15"
              placeholder="请再次输入密码"
            ></el-input>
          </el-form-item>
<!--          <el-form-item label="授权委托书" prop="grantCard">-->
<!--            <span slot="label">-->
<!--              <span> 授权委托书 </span><br />-->
<!--              <span class="form-label-slot">(请上传小于4M的jpg格式图片)</span>-->
<!--            </span>-->
<!--            <el-upload-->
<!--              class="avatar-uploader"-->
<!--              v-model="register.grantCard"-->
<!--              :show-file-list="false"-->
<!--              :on-success="handleSuccess"-->
<!--              :before-upload="beforeGrantCardUpload"-->
<!--            >-->
<!--              <img-->
<!--                v-if="register.grantCard"-->
<!--                :src="register.grantCard"-->
<!--                class="avatar"-->
<!--                fit="scale-down"-->
<!--              />-->
<!--              <i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
<!--            </el-upload>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="委托截止期限" prop="grantDate">-->
<!--            <el-date-picker-->
<!--              type="date"-->
<!--              placeholder="请选择委托截止期限"-->
<!--              v-model="register.grantDate"-->
<!--              style="width: 100%"-->
<!--            ></el-date-picker>-->
<!--          </el-form-item>-->
          <el-form-item label="手写签名" prop="signImg">
            <span slot="label">
              <span> 手写签名 </span><br />
              <span class="form-label-slot">(请上传小于4M的jpg格式图片)</span>
            </span>
            <el-upload
              class="avatar-uploader"
              v-model="register.signImg"
              :show-file-list="false"
              :on-success="handleSuccess"
              :before-upload="beforeSignImgUpload"
            >
              <img
                v-if="register.signImg"
                :src="register.signImg"
                class="avatar"
                fit="scale-down"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-form>
        <el-row>
          <el-button type="primary" @click="submitForm('register')" size="mini"
            >注册</el-button
          >
          <el-button size="mini" @click="resetForm('register')">重置</el-button>
          <el-button size="mini" @click="closeForm">关闭</el-button>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
var baseUrl = process.env.API_ROOT;
export default {
  name: "CheckLogin",
  data() {
    const equalToPassword = (rule, value, callback) => {
      if (this.register.password !== value) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    };
    const fileIsJPG = (rule, value, callback) => {
      if (!value) {
        // if (rule.fullField === "grantCard") {
        //   callback(new Error("请选择授权委托书"));
        //   return;
        // } else
          if (rule.fullField === "signImg") {
          callback(new Error("请选择手写签名"));
          return;
        }
      }
      let file = this.base64ToFile(value);
      if (file.type !== "image/jpeg") {
        callback(new Error("请上传jpg格式图片"));
        return;
      }
      if (file.size / 1024 / 1024 > 4) {
        callback(new Error("请上传小于4M格式图片"));
        return;
      }
      callback();
    };
    const passwordCheck = (rule, value, callback) => {
      if(!value){
        callback(new Error("请输入密码"))
      }
      let pattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[~!@#$%^&*)(_+}{|:?><]).{6,20}$/;
      if(!pattern.test(value)){
        callback(new Error("密码长度必须6到20位且包含大小写字母，数字以及特殊字符"));
        return;
      }else{
        callback();
      }
    };
    return {
      rememberPsw: true,
      username: "",
      password: "",
      code: "",
      //注册信息
      register: {
        supplierNo: "",
        supplierName: "",
        userCode: "",
        openId: "",
        userName: "",
        password: "",
        passwordEnter: "",
        signImg:
          "data:image/png;base64,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",
        grantCard: "",
        licenseNo: "",
      },
      validRules: {
        supplierNo: [
          { required: true, message: "请输入十位能源1号网MDM编码", trigger: "blur" },
          // { min: 15, max: 18, message: '长度在 15 到 18 个字符', trigger: 'blur' }
        ],
        supplierName: [
          { required: true, message: "请输入供应商名称", trigger: "blur" },
          {
            min: 5,
            max: 100,
            message: "长度在 5 到 100 个字符",
            trigger: "blur",
          },
        ],
        userPhone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "手机号码格式不正确",
            trigger: "blur",
          },
        ],
        userCode: [
          // { required: true, message: "请输入登录名", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "长度在 2 到 20 个字符",
            trigger: "blur",
          },
        ],
        userName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 2, max: 4, message: "长度在 2 到 4 个字符", trigger: "blur" },
        ],
        password: [
          { required: true, validator: passwordCheck, trigger: "blur" },
        ],
        passwordEnter: [
          { required: true, message: "请输入确认密码", trigger: "blur" },
          { required: true, validator: equalToPassword, trigger: "blur" },
        ],
        grantDate: [
          { required: true, message: "请输入委托截止期限", trigger: "blur" },
        ],
        licenseNo: [
          { required: true, message: "请选择营业执照", trigger: "blur" },
        ],
        grantCard: [{ required: true, trigger: "blur", validator: fileIsJPG }],
        signImg: [{ required: true, trigger: "blur", validator: fileIsJPG }],
      },
      //注册or登录
      registerVisible: false,
    };
  },
  methods: {
    //登录接口
    login() {
      if (this.username == "") {
        this.$dialog.toast({ mes: "请输入手机号", timeout: 1500 });
        return;
      }
      if (this.password == "") {
        this.$dialog.toast({ mes: "请输入密码", timeout: 1500 });
        return;
      }

      if (this.rememberPsw) {
        window.localStorage.setItem("psw", this.password);
        window.localStorage.setItem("user", this.username);
      }
      axios({
        method: "get",
        url:
          baseUrl +
          "checkLogin?username=" +
          this.username +
          "&password=" +
          encodeURIComponent(this.password) +
          "&openId=" +   window.localStorage.getItem("openid"),
      }).then((resp) => {
        if (resp.data.error_code == "0") {
          window.localStorage.setItem("supplierStatus", "0");
          window.localStorage.setItem("checkUserId", resp.data.data.userId);
          window.localStorage.setItem("grantDateExpired", resp.data.data.grantDateExpired);

          let roleName = resp.data.data.role;
          // if(resp.data.data.grantDateExpired){
          //   this.$dialog.confirm({
          //     title: '提示',
          //     mes: '委托书即将过期，请更新授权委托书！',
          //     opts: [
          //       {
          //         txt: '取消',
          //         color: false,
          //         callback: () => {}
          //       },
          //       {
          //         txt: '确定',
          //         color: true,
          //         callback: () => {
          //
          //         }
          //       }
          //     ]
          //   });
          // }
          if (roleName === "mso") {
            this.$router.push({ path: "/msoIndex" });
          } else {
            this.$router.push({ path: "/supplierIndex" });
          }
        }else if (resp.data.error_code == "2") {
          let roleName = resp.data.data.role;
          window.localStorage.setItem("supplierStatus", "2");
          window.localStorage.setItem("checkUserId", resp.data.data.userId);
          window.localStorage.setItem("grantDateExpired", resp.data.data.grantDateExpired);
          if (roleName === "mso") {
            this.$router.push({ path: "/msoIndex" });
          } else {
            this.$router.push({ path: "/supplierIndex" });
          }
          // this.$dialog.confirm({
          //   title: '提示',
          //   mes: '委托书过期，请更新授权委托书！',
          //   opts: [
          //     {
          //       txt: '取消',
          //       color: false,
          //       callback: () => {
          //         if (roleName === "mso") {
          //           this.$router.push({ path: "/msoIndex" });
          //         } else {
          //           this.$router.push({ path: "/supplierIndex" });
          //         }
          //       }
          //     },
          //     {
          //       txt: '确定',
          //       color: true,
          //       callback: () => {
          //         this.$router.push({ path: "/updateGrant"});
          //       }
          //     }
          //   ]
          // });
        }else if (resp.data.error_code == "3") {
          let roleName = resp.data.data.role;
          window.localStorage.setItem("supplierStatus", "3");
          window.localStorage.setItem("checkUserId", resp.data.data.userId);
          window.localStorage.setItem("grantDateExpired", resp.data.data.grantDateExpired);
          if (roleName === "mso") {
            this.$router.push({ path: "/msoIndex" });
          } else {
            this.$router.push({ path: "/supplierIndex" });
          }
          // this.$dialog.confirm({
          //   title: '提示',
          //   mes: '审批未通过，请耐心等待，如果需要紧急办理请拨打电话：029-86595044，请联系管理员！',
          //   opts: [
          //     {
          //       txt: '取消',
          //       color: false,
          //       callback: () => {
          //         if (roleName === "mso") {
          //           this.$router.push({ path: "/msoIndex" });
          //         } else {
          //           this.$router.push({ path: "/supplierIndex" });
          //         }
          //       }
          //     },
          //     {
          //       txt: '确定',
          //       color: true,
          //       callback: () => {
          //         this.$router.push({ path: "/supplierEdit"});
          //       }
          //     }
          //   ]
          // });
        }else if (resp.data.error_code == "4") {
          let roleName = resp.data.data.role;
          window.localStorage.setItem("supplierStatus", "4");
          window.localStorage.setItem("checkUserId", resp.data.data.userId);
          window.localStorage.setItem("grantDateExpired", resp.data.data.grantDateExpired);
          if (roleName === "mso") {
            this.$router.push({ path: "/msoIndex" });
          } else {
            this.$router.push({ path: "/supplierIndex" });
          }
          // this.$dialog.confirm({
          //   title: '提示',
          //   mes: '管理员未审批，请耐心等待，如果需要紧急办理请拨打电话：029-86595044，请联系管理员！！',
          //   opts: [
          //     {
          //       txt: '取消',
          //       color: false,
          //       callback: () => {
          //         if (roleName === "mso") {
          //           this.$router.push({ path: "/msoIndex" });
          //         } else {
          //           this.$router.push({ path: "/supplierIndex" });
          //         }
          //       }
          //     },
          //     {
          //       txt: '确定',
          //       color: true,
          //       callback: () => {
          //       }
          //     }
          //   ]
          // });
        }else {
          if(resp.data.error_msg){
            this.$dialog.toast({ mes: resp.data.error_msg, timeout: 1500 });
          }else{
            this.$dialog.toast({ mes: '登录失败', timeout: 1500 });
          }
        }
      });
    },
    fileToBase64Async(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          resolve(e.target.result);
        };
      });
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleSuccess(res, file) {},

    beforeLicenseNoUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt4M = file.size / 1024 / 1024 < 4;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt4M) {
        this.$message.error("上传头像图片大小不能超过 4MB!");
      }
      this.fileToBase64Async(file).then((result) => {
        this.register.licenseNo = result;
      });

      return isJPG && isLt2M;
    },
    beforeGrantCardUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt4M = file.size / 1024 / 1024 < 4;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt4M) {
        this.$message.error("上传头像图片大小不能超过 4MB!");
      }
      this.fileToBase64Async(file).then((result) => {
        this.register.grantCard = result;
      });
      return isJPG && isLt2M;
    },
    beforeSignImgUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt4M = file.size / 1024 / 1024 < 4;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt4M) {
        this.$message.error("上传头像图片大小不能超过 4MB!");
      }
      this.fileToBase64Async(file).then((result) => {
        this.register.signImg = result;
      });
      return isJPG && isLt2M;
    },

    submitForm(formName) {
      let that = this;

      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "正在注册，请稍后....",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.6)",
          });
          this.register.openId=window.localStorage.getItem("openid");
          axios({
            method: "post",
            url: baseUrl + "register",
            data: this.register,
          }).then((resp) => {
            loading.close();
            if (resp.data.error_code == "0") {
              this.$dialog.toast({ mes: "注册成功" });
              closeForm();
            } else {
              this.$dialog.toast({ mes: resp.data.message, timeout: 1500 });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    closeForm() {
      this.registerVisible = false;
    },
    //获取微信Code
    getcode() {
      window.localStorage.clear();
      let queryParams = this.extractQueryParams(window.location.href);
      this.code = queryParams.code;
      let appid = process.env.WX_APPID;
      let redirect_uri = process.env.WX_REDIRECT_URI;
      if (this.code == "" || this.code == undefined) {
        let authParams = `?appid=${appid}&redirect_uri=${redirect_uri}&response_type=${"code"}&state=${"123"}&scope=${"snsapi_userinfo"}#wechat_redirect`;
        location.replace(
          "https://open.weixin.qq.com/connect/oauth2/authorize" + authParams
        );
      } else {
        axios({
          method: "get",
          url: baseUrl + "getopenid?code=" + this.code,
        }).then((resp) => {
          if (resp.data.error_code == "0") {
            window.localStorage.setItem("openid", resp.data.openid);
          } else {
            // this.$dialog.toast({ mes: "获取openId失败", timeout: 1500 });
            return;
          }
        });
      }
    },
    extractQueryParams(url) {
      let queryParams = {};
      if (url.includes("?")) {
        let queryString = url.substr(url.indexOf("?") + 1);
        let pairs = queryString.split("&");
        for (let pair of pairs) {
          let splitArray = pair.split("=");
          let key = splitArray[0];
          let value = splitArray[1];
          if (value.indexOf("#") > -1) {
            value = value.substring(0, value.indexOf("#"));
          }
          queryParams[key] = value;
        }
      }
      return queryParams;
    },
    getOpenId(code) {
      // 通过code获取 openId等用户信息，/api/user/wechat/login 为后台接口
      axios({
        method: "get",
        url: baseUrl + "getopenid?code=" + this.code,
      }).then((resp) => {
        if (resp.data.error_code == "0") {
          window.localStorage.setItem("openid", resp.data.openid);
          this.register.openid = resp.data.openid;
        } else {
          // this.$dialog.toast({ mes: "获取openId失败", timeout: 1500 });
        }
      });
    },
    initPsw() {
      if (this.rememberPsw) {
        const psw = window.localStorage.getItem("psw");
        const name = window.localStorage.getItem("user");
        this.username = name;
        this.password = psw;
      }
    },
    getSupplierName(event) {
      let supplierCode = event.srcElement.value;
      axios({
        method: "get",
        url: baseUrl + "getSupplierName?supplierCode=" + supplierCode,
      }).then((resp) => {
        if (resp.data.error_code == "0") {
          this.register.supplierName = resp.data.supplierName;
        }
      });
    },
    base64ToFile(urlData, fileName) {
      if (!fileName) {
        fileName = "default";
      }
      let arr = urlData.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bytes = atob(arr[1]); // 解码base64
      let n = bytes.length;
      let ia = new Uint8Array(n);
      while (n--) {
        ia[n] = bytes.charCodeAt(n);
      }
      return new File([ia], fileName, { type: mime });
    },
  },
  mounted() {
    //this.getOpenId();
    this.initPsw();
    //this.login()
  },
  created() {
    this.getcode();
  }
};
</script>

<style scoped>
.wrap /deep/ .yd-tab-nav .yd-tab-active {
  color: rgba(47, 111, 255, 1) !important;
}
.wrap /deep/ .yd-preview-footer:before {
  height: 2px;
}

/deep/ .avatar-uploader {
  border: 1px rgba(0, 0, 0, 0.5) dashed;
  height: 100px;
  line-height: 100px;
}
.avatar {
  height: 100px;
}
.nav-title {
  padding-top: 20px;
  font-size: 18px;
}
.form-label-slot {
  font-size: 8px !important;
  color: cornflowerblue;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue